import { z } from 'zod';
import { optionalMongoObjectId } from './object-id-helpers.js';

const poolItemSchema = z.object({
    type: z.enum(['title', 'unit', 'role', 'user']).optional(),
    value: z.string().optional(),
    label: z.string().optional(),
});

const severityEnum = z.enum(['critical', 'high', 'medium', 'low']);
const typeEnum = z.enum(['security', 'safety', 'operational', 'compliance', 'other']);

export const CreateIncidentTemplateSchema = z.object({
    name: z.string().min(1),
    code: z.string().optional(),
    description: z.string().optional(),
    type: typeEnum.optional(),
    category: z.string().optional(),
    severity: severityEnum.optional(),
    impact: severityEnum.optional(),
    urgency: severityEnum.optional(),
    defaultAssigneePool: z.array(poolItemSchema).optional(),
    defaultWorkflowTemplate: optionalMongoObjectId,
    defaultSla: optionalMongoObjectId,
    status: z.enum(['draft', 'published', 'archived']).optional(),
    customFields: z.record(z.unknown()).optional(),
});

export const UpdateIncidentTemplateSchema = CreateIncidentTemplateSchema.partial();
